export function home() {
    const $injector = angular.element(document).injector();
    const $rootScope = $injector.get('$rootScope');
    $injector.get('$location').path('/');
    if (!$rootScope.$$phase) {
        $rootScope.$apply();
    }
}
